import { Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { SlideUp } from "../misc/SlideUp";
import { DialogCloseButton } from "../misc/DialogCloseButton";
import { useState } from "react";

interface ConfirmDialogProps {
  readonly open: boolean;
  readonly onClose: () => void;
  readonly title: string;
  readonly message: string;
  readonly confirmButtonLabel: string;
  readonly onConfirm: () => Promise<void>;
}

export function ConfirmDialog({ open, onClose, title, message, confirmButtonLabel, onConfirm }: ConfirmDialogProps) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const onClick = async () => {
    setIsSubmitting(true);
    await onConfirm();
    setIsSubmitting(false);
  };

  return (
    <Dialog open={open} onClose={onClose} TransitionComponent={SlideUp}>
      <DialogTitle>{title}</DialogTitle>
      <DialogCloseButton onClick={onClose} />
      <DialogContent>
        <Typography>{message}</Typography>
      </DialogContent>
      <DialogActions>
        <LoadingButton variant="contained" color="error" loading={isSubmitting} onClick={onClick}>
          {confirmButtonLabel}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
